// extracted by mini-css-extract-plugin
export default {"grid":"StatusDashboard_grid__l1Kr-","link":"StatusDashboard_link__vucQw"};